module.exports = __webpack_public_path__ + "img/ez-slot-category-brand.bae8ec39.png";